import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m6.4 2.75 1.82-.43c.5-.12 1.01.16 1.17.65l.85 2.59c.15.46-.03.96-.43 1.22l-1.39.9A7.67 7.67 0 0 0 12 11.26l.9-1.39c.26-.4.76-.58 1.22-.43l2.59.85c.49.16.77.67.65 1.17l-.43 1.82c-.16.68-.77 1.16-1.47 1.16-5.6 0-10.22-4.62-10.22-10.22 0-.7.48-1.31 1.16-1.47"
    }, null, -1)
  ]))]))
}
export default { render: render }